import { ProductLevel } from 'pricing-pages-ui-components/constants/ProductLevel';
export const CRM_SUITE_STARTER = 'suitestarter';
export const CRM_SUITE_STARTER_AUG_21 = 'suitestarteraug2021';
export const CRM_SUITE_PROFESSIONAL = 'suiteprofessional';
export const CRM_SUITE_ENTERPRISE = 'suiteenterprise';
export const SUITE_STARTER = 'growthstarter';
export const SUITE_PROFESSIONAL = 'growthprofessional';
export const SUITE_ENTERPRISE = 'growthenterprise';
export const BUNDLE = 'bundle';
export const CMS_HUB_MARKETING_STARTER = 'marketingstartercmshub';
export const COVID_PROMO_SUITE_STARTER = 'growthstarter-covid';
export const SUITE_STARTER_MC = 'growthstarter-mc';
export const SUITE_STARTER_COVID_MC = 'growthstarter-mc-covid';
export const SUITE_PROFESSIONAL_MC = 'growthprofessional-mc';
export const SUITE_ENTERPRISE_MC = 'growthenterprise-mc';
export const MARKETING_AND_SALES_STARTER = 'marketing-hub-starter-sales-hub-starter';
export const MARKETING_AND_SERVICE_STARTER = 'marketing-hub-starter-service-hub-starter';
export const SALES_AND_SERVICE_STARTER = 'sales-hub-starter-service-hub-starter';
export const ProductLevelToSuiteNonMerchandiseIdMap = {
  [ProductLevel.STARTER]: CRM_SUITE_STARTER_AUG_21,
  [ProductLevel.PROFESSIONAL]: CRM_SUITE_PROFESSIONAL,
  [ProductLevel.ENTERPRISE]: CRM_SUITE_ENTERPRISE
};